var map = {
	"./background_home.svg": "89d5",
	"./background_instructions.svg": "b02b",
	"./background_main_game.png": "a8ed",
	"./background_main_game.svg": "239a",
	"./bubble_correct.svg": "5614",
	"./bubble_incorrect.svg": "fc18",
	"./cauldronActive.svg": "306b",
	"./cauldronInactive.svg": "b6aa",
	"./clock_test.png": "6d22",
	"./clocks/eight_fifty.svg": "46ee",
	"./clocks/eight_ten.svg": "8720",
	"./clocks/eleven_forty.svg": "c55a",
	"./clocks/five_twenty.svg": "0bba",
	"./clocks/four_ten.svg": "761a",
	"./clocks/nine_ten.svg": "cfd0",
	"./clocks/nine_thirty_five.svg": "f864",
	"./clocks/seven_fifty.svg": "3053",
	"./clocks/seven_o_clock.svg": "02f8",
	"./clocks/six_forty.svg": "c879",
	"./clocks/six_twenty_five.svg": "b8f5",
	"./clocks/three_forty_five.svg": "e312",
	"./clocks/three_thirty.svg": "6297",
	"./clocks/twelve_fifteen.svg": "23a5",
	"./clocks/two_five.svg": "04e9",
	"./house.png": "7eeb",
	"./mute.svg": "4c76",
	"./pumpkin.png": "c53c",
	"./pumpkin_happy.png": "03a0",
	"./pumpkin_sad.png": "efda",
	"./retry.svg": "2c08",
	"./speaker.svg": "01fe",
	"./stars_left.svg": "732c",
	"./stars_right.svg": "ad35",
	"./witch_avatar.svg": "e38a",
	"./witch_home.png": "b34d",
	"./z-other-witch_home.svg": "b7d3",
	"./z-other_Rectangle 5.svg": "86f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ace88";